import { render, staticRenderFns } from "./InformationDefault.vue?vue&type=template&id=60f9ad3a&scoped=true&lang=html"
import script from "./InformationDefault.vue?vue&type=script&lang=js"
export * from "./InformationDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9ad3a",
  null
  
)

export default component.exports